import axios from "../axios.config";

const state = {
  integrationCatalog: [],
  vivoGestaoAccesses: [],
  opera360Access: null,
};

const actions = {
  async loadIntegrationCatalog({ commit }) {
    try {
      const { data } = await axios.get("/integrations");
      if (data.success === false) {
        throw new Error(data.message);
      }
      commit("SET_INTEGRATION_CATALOG", data.data);
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  },

  async loadVivoGestaoAccesses({ commit }) {
    try {
      const { data } = await axios.get("/integrations/vivo_gestao/accesses");
      if (data.success === false) {
        throw new Error(data.message);
      }
      commit("SET_VIVO_GESTAO_ACCESSES", data.data);
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  },

  async saveVivoGestaoAccess(_, params) {
    try {
      const { data } = await axios.post("/integrations/vivo_gestao/accesses", params);
      if (data.success === false) {
        throw new Error(data.message);
      }
      return data.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  },

  async updateVivoGestaoAccess(_, params) {
    try {
      const { data } = await axios.put(
        `/integrations/vivo_gestao/accesses/${params.id}`,
        params
      );
      if (data.success === false) {
        throw new Error(data.message);
      }
      return data.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  },

  async deleteVivoGestaoAccess(_, id) {
    try {
      const { data } = await axios.delete(`/integrations/vivo_gestao/accesses/${id}`);
      if (data.success === false) {
        throw new Error(data.message);
      }
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  },

  async loadOpera360Access({ commit }) {
    try {
      const { data } = await axios.get("/integrations/opera360/access");
      if (data.success === false) {
        throw new Error(data.message);
      }
      commit("SET_OPERA360_ACCESS", data.data);
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  },

  async saveOpera360Access(_, params) {
    try {
      const { data } = await axios.post("/integrations/opera360/access", params);
      if (data.success === false) {
        throw new Error(data.message);
      }
      return data.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  },

  async updateOpera360Access(_, params) {
    try {
      const { data } = await axios.put("/integrations/opera360/access", params);
      if (data.success === false) {
        throw new Error(data.message);
      }
      return data.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  },

  async deleteOpera360Access() {
    try {
      const { data } = await axios.delete("/integrations/opera360/access");
      if (data.success === false) {
        throw new Error(data.message);
      }
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  },

  async testOpera360Access() {
    try {
      const { data } = await axios.post("/integrations/opera360/access/test");
      if (data.success === false) {
        const error = new Error(data.message);
        error.details = data.data || {};
        throw error;
      }
      return data.data;
    } catch (error) {
      if (error.details) {
        throw error;
      }
      const responseData = error.response?.data;
      const apiError = new Error(responseData?.message || error.message);
      apiError.details = responseData?.data || {};
      throw apiError;
    }
  },
};

const mutations = {
  SET_INTEGRATION_CATALOG: (state, data) => {
    state.integrationCatalog = data;
  },
  SET_VIVO_GESTAO_ACCESSES: (state, data) => {
    state.vivoGestaoAccesses = data;
  },
  SET_OPERA360_ACCESS: (state, data) => {
    state.opera360Access = data;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
